<script>
export default {
  name: "processing-performance",
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
}

</script>

<template>
  <b-card
      class="mb-4"
      no-body
  >
    <b-card-body>
      <h3 class="dashboard-card-header mb-4">{{ lodash.startCase($t('performance_dashboards.processing_performance')) }}</h3>
      <b-table-simple responsive>
        <b-thead>
          <b-tr>
            <b-th>Kode</b-th>
            <b-th>Pabrik</b-th>
            <b-th class="text-end" style="width: 125px">% AVG Tonase</b-th>
            <b-th class="text-end" style="width: 125px">% AVG Size</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <template v-if="data.length">
            <b-tr v-for="datum in data" :key="datum.id">
              <b-td>{{ datum.code }}</b-td>
              <b-td>{{ datum.name }}</b-td>
              <b-td class="text-end" style="width: 125px">{{ $numeral(datum.performance.quantity.avg).format('0,0.00') }}%</b-td>
              <b-td class="text-end" style="width: 125px">{{ $numeral(datum.performance.size.avg).format('0,0.00') }}%</b-td>
            </b-tr>
          </template>
          <template v-else>
            <b-tr>
              <b-td colspan="5">
                <div class="card shadow-none rounded-0" style="margin: -0.75rem; background-color: #F5F6F7; min-height: 225px; position: relative;">
                  <div
                      style="position: absolute;
                  left: 50%;
                  top: 40%;
                  transform: translate(-50%, -50%);"
                  >
                    <p class="table-status-text pt-4">{{ lodash.upperFirst($t('performance_dashboards.empty_filtered_data_message')) }}</p>
                  </div>
                </div>
              </b-td>
            </b-tr>
          </template>
        </b-tbody>
      </b-table-simple>
    </b-card-body>

  </b-card>
</template>

<style lang="scss" scoped>
.table-responsive {
  height: 250px;
}
thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #fff;
  box-shadow: 0 1px 2px rgba(0,0,0,0.1);
}
</style>